<template>
  <div>
    <!-- Tabla con la lista de dispositivos-->
    <div>
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :row-style-class="rowStyleGrupos"
        @on-row-click="loadView"
        :search-options="{
          enabled: false,
          skipDiacritics: true,
          placeholder: 'Buscar en la tabla',
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'alias', type: 'asc' },
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 5,
          dropdownAllowAll: false,
          //setCurrentPage: 2,
          nextLabel: '',
          prevLabel: '',
          rowsPerPageLabel: 'Filas por pagina',
          ofLabel: 'de',
          pageLabel: 'pagina', // for 'pages' mode
          allLabel: 'Todas',
        }"
        :isLoading.sync="isLoading"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'acciones'">
            <span style="margin-right: 10px"  @click="viewRow(props.row.uuid)">
              <i class="far fa-eye fa-lg" style="cursor: pointer" title="Ampliar detalles de agrupación"></i>
            </span>            
            <span style="margin-right: 10px" @click="editRow(props.row.uuid)">
              <i class="far fa-edit fa-lg" style="cursor: pointer" title="Editar detalles de agrupación"></i>
            </span>
            <span  @click="deleteModalPopup(props.row.uuid)" v-if="isUserAdmin()">
              <i class="far fa-trash-alt fa-lg" style="cursor: pointer" title="Borrar detalles de agrupación"></i>
            </span>
          </span>
        </template>

        <template slot="loadingContent">
          <table-loading />
        </template>
        <template slot="emptystate">
          <table-empty-state />
        </template>
      </vue-good-table>
    </div>
  </div>
</template>


<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import GroupService from "@/services/GroupService";
import UserService from "@/services/UserService";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";

export default {
  name: "group-list",
  data() {
    return {
      group: [],
      currentGroup: null,
      currentIndex: -1,
      alias: "",
      isLoading: false,
      selectedGroupId: -1,
      parentLocation: null,
      columns: [
        {
          label: "# UUID",
          thClass: "text-center",
          tdClass: "text-center",
          field: "uuid",
          hidden: true,
        },
        {
          label: "Alias agrupación",
          field: "alias",
          type: "string",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Sensores vinculados",
          field: "conteosensores",
          thClass: "text-center",
          tdClass: "text-center",
          type: "string",
        },
        {
          label: "Sensores SHM",
          thClass: "text-center",
          tdClass: "text-center",
          field: "conteoshm",
        },
        {
          label: "Última medida SHM",
          thClass: "text-center",
          tdClass: "text-center",
          field: "ultimamedidashm",
        },
        {
          label: "Acciones",
          thClass: "text-center",
          tdClass: "text-center",
          field: "acciones",
        },
      ],
      rows: [],
    };
  },
  components: {
    VueGoodTable,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
  },
  methods: {
    retrieveGroup(location) {
      this.parentLocation = location
      this.isLoading = true;
      GroupService.getGroupListByLocationId(location._id)
        .then((response) => {
          this.group = response.data;
          //Cuidado esto puede cortar el lleado del array
          //en caso de que no exista algún campo
          this.populateRows();
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
          console.log("Error recuperando lista de grupos");
          console.log(e);
        });
    },

    refreshList(location) {
      this.rows = [];
      this.retrieveGroup(location);
    },

    deleteGroup(idgroup) {
      GroupService.delete(idgroup)
        .then((response) => {
          //Mostrar mensaje
          this.$notify({
            group: "notificateDiv",
            type: "pepito",
            title: "Grupo eliminado correctamente",
            duration: 3000,
            speed: 1000,
          });
          //Quitar del array caragdo la Fila
          this.refreshList(this.parentLocation);
          //Refrescar tabla
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async populateRows() {
      //Clean array before recreate it
      this.rows = []
      //Create struct before insert it
      let newData = null;

      //Add to array
      for (let i = 0; i < this.group.length; i++) {
        // Fill sensor list
        let sensorNumber = 0;
        let shmNumber = 0;

        await GroupService.getSensorCountFromId(this.group[i]._id)
        .then(response => {
          if (response.data) {
            if (parseInt(response.data.sensorNumber)!=NaN) {
              sensorNumber = response.data.sensorNumber;
            }
            if (parseInt(response.data.shmNumber)!=NaN) {
              shmNumber = response.data.shmNumber;
            }
          }
        })
        .catch(err => {
          console.log("Error recuperando conteos de sensores")
          console.log(err)
        })

        //Fill the struct
        newData = {
          uuid: this.group[i]._id,
          alias: this.group[i].alias,
          conteosensores: sensorNumber,
          conteoshm: shmNumber,
          ultimamedidashm: "Solicitando...",
        };

        //Push the data to the array
        this.rows.push(newData);
      }

      // Now get last shm measure from each group
      for (let i = 0; i < this.rows.length; i++) {
        await GroupService.getLastShm(this.rows[i].uuid)
          .then(async (response) => {
            
            if (response.data) {
              this.rows[i].ultimamedidashm = this.$moment(String(response.data)).local().format("DD/MM/YYYY HH:mm:ss");
            } else {
              this.rows[i].ultimamedidashm = "Sin medida";
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }

    },

    editRow(idgroup) {
      //Emit from child to parent idnodo to be modified
      this.$emit("rowedit", idgroup);
    },

    viewRow(idgroup) {
      //Emit from child to parent idnodo to be modified
      this.$emit("rowview", idgroup);
    },

    deleteModalPopup(idgroup) {
      this.$bvModal
        .msgBoxConfirm(
          "Recuerde que una vez borrado el grupo no podra ser recuperado de nuevo.",
          {
            title:
              "¿Estad usted seguro de borrar el grupo seleccionado del sistema?",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Si, quiero borrarlo",
            cancelTitle: "No, me he equivocado",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value == true) {
            this.deleteGroup(idgroup);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },

    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    loadView(params){
      //do nothing
      //Mark row to change style
      //this.viewRow(params.row.uuid);  
    },

    rowStyleGrupos(row) {
      return row.uuid == this.selectedGroupId ? "selectedTableRow" : "";
    },    

    async generateSensorAliasString(i) {
      let sensorAliasList = [];
      let sensorAliasString;

      if (
        this.group[i].sensor &&
        this.group[i].sensor.length &&
        this.group[i].sensor.length > 0
      ) {
        for await (let sensor of this.group[i].sensor) {
          sensorAliasList.push(sensor.description);
        }
        sensorAliasString = sensorAliasList.join(", ");

        return sensorAliasString;
      } else {
        sensorAliasString = "Sin sensores asociados";

        return sensorAliasString;
      }
    },
  },
  mounted() { },
};
</script>

<style>
.groupTable {
  padding: 20px 20px 20px 20px;
}
</style>
